import { Page } from './pages';

import { PATH } from '../../constants';

export default {
  component: Page,
  name: 'Dashboard',
  path: PATH.DASHBOARD
};
